export const SearchIcon = ({
  color = '#0064FF', label = 'Search', ...props
}) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    viewBox={'-2 -2 20 20'}
    fill={'none'}
    {...props}
  >
    <title>{label}</title>
    <path
      d={'M10.9571 9.54289C10.5666 9.15237 9.93342 9.15237 9.54289 9.54289C9.15237 9.93342 9.15237 10.5666 9.54289 10.9571L10.9571 9.54289ZM14.0429 15.4571C14.4334 15.8476 15.0666 15.8476 15.4571 15.4571C15.8476 15.0666 15.8476 14.4334 15.4571 14.0429L14.0429 15.4571ZM6.5 10.75C4.15279 10.75 2.25 8.84721 2.25 6.5H0.25C0.25 9.95178 3.04822 12.75 6.5 12.75V10.75ZM2.25 6.5C2.25 4.15279 4.15279 2.25 6.5 2.25V0.25C3.04822 0.25 0.25 3.04822 0.25 6.5H2.25ZM6.5 2.25C8.84721 2.25 10.75 4.15279 10.75 6.5H12.75C12.75 3.04822 9.95178 0.25 6.5 0.25V2.25ZM10.75 6.5C10.75 8.84721 8.84721 10.75 6.5 10.75V12.75C9.95178 12.75 12.75 9.95178 12.75 6.5H10.75ZM9.54289 10.9571L14.0429 15.4571L15.4571 14.0429L10.9571 9.54289L9.54289 10.9571Z'}
      fill={color}
    />
  </svg>
);
